
import {METHOD_NOT_IMPL, SINGLETON_CLASS} from "@kta20-core/constants";
import {EventTarget} from '@kta20-core/core-module';
import {IAuthService} from "@kta20-core/interfaces/auth/i-auth-service";
import {IUserInfoAdapter} from "@kta20-core/interfaces/auth/i-user-info-adapter";
import {IAuthProviderError} from "@kta20-core/interfaces/auth/i-auth-provider-error";
import {UserInfo} from "@kta20-core/models/auth/user-info";
import {AuthServiceEvents} from "@kta20-core/auth/auth-service-events";

const TOKEN_KEY = 'ls.token';
const MethodNotImplementedException = new Error(METHOD_NOT_IMPL);

export class AuthService extends EventTarget implements IAuthService {

    private static _inst: AuthService;
    private userInfoAdapter:IUserInfoAdapter;
    private expSpanInterval: number;


    constructor() {
        super();
        if (AuthService._inst) throw new Error(SINGLETON_CLASS);
    }

    static get(
        sessionAlertTimeSpan?:number,
        userInfoAdapter?:IUserInfoAdapter,
        platform4Auth?:any
    ): AuthService {
        platform4Auth;
        sessionAlertTimeSpan;

        if (!this._inst)  {
            this._inst = new AuthService();
            this._inst.userInfoAdapter = userInfoAdapter;

            //Init() happens also when the user is redirected back from
            //the auth provider to the KT login view.
            //if(!this._inst.getToken()) this._inst.readAuthResponse();
        }

        return this._inst;
    }

    isTokenExpired():boolean{
        return this.getToken()===null; //KT1 token never expires :(:(
    }

    isTokenAboutToExpire(): boolean {
        return this.getToken()===null; //KT1 token never expires :(:(
    }

    getToken(): string {
        const tokenStr = localStorage.getItem(TOKEN_KEY); //safe to invoke localStorage since KT1 is web only and only uses localStorage
        return tokenStr? JSON.parse(tokenStr).access_token : null;
    }

    storeToken(token):IAuthService{
        localStorage.setItem(TOKEN_KEY, token); //safe to invoke localStorage since KT1 is web only and only uses localStorage
        return this;
    }

    async getUserInfo():Promise<UserInfo>{
        if(!this.userInfoAdapter) {
            console.error(
                `During service initialization please 
                pass an implementation of IUserInfoAdapter 
                to then get user info with this method.`
            );
            throw MethodNotImplementedException;
        }

        return await this.userInfoAdapter.getUserInfo(this.getToken());
    }

    getUserInfoAdapter():IUserInfoAdapter {
        return this.userInfoAdapter;
    }

    setUserInfoAdapter(userInfoAdapter:IUserInfoAdapter):IAuthService{
        this.userInfoAdapter = userInfoAdapter;
        return this;
    }

    watchExpiration():AuthService{
        this.expSpanInterval = <number><any>setInterval(()=>{
            if(this.isTokenExpired()) {
                window.clearInterval(this.expSpanInterval);
                this.dispatchEvent(new CustomEvent(AuthServiceEvents.SESSION_ABOUT_TO_EXPIRE));
            }
        },5*1000);

        return this;
    }


    //=================================================================
    // UNSUPPORTED IN KT1 APP FLOW LOGIC WHEN KTA20 IS EMBEDDED INTO KT1
    //=================================================================

    getAuthProviderResponseValue(keyName:string):string{
        keyName;
        throw MethodNotImplementedException;
    }

    readAuthResponse(){
        throw MethodNotImplementedException;
    }

    getAuthProviderError():IAuthProviderError{
        throw MethodNotImplementedException;
    }

    async redirectToAuthProviderLogin(loginUrl:string, logoutUrl:string):Promise<IAuthService>{
        loginUrl;logoutUrl;
        throw MethodNotImplementedException;
    }

    logout():IAuthService {
        throw MethodNotImplementedException;
    }

    getExpireTime(token):number {
        token;
        throw MethodNotImplementedException;
    }

    getNonce(token): string {
        token;
        throw MethodNotImplementedException;
    }

    watchExpirationSpan():AuthService{
        throw MethodNotImplementedException;
    }

    //=================================================================

}